import React from 'react';
import SocialMediaIcon from './SocialMediaIcon';

type PlatformType = 'github' | 'linkedin' | 'twitter' | 'instagram';

export default function SocialMediaSection(): React.ReactElement {
    const platforms: PlatformType[] = ['github', 'linkedin'];
    
    return (
        <div className="flex gap-3">
            {platforms.map((platform) => (
                <SocialMediaIcon type={platform} key={platform} />
            ))}
        </div>
    );
}
